const parsePhoneNumber = (number) =>
  number ? number.replace(/[^\d]/g, '') : ''

export default parsePhoneNumber
